import { useMediaQuery } from '@kite-js/core';

export function useIsMobile(customMediaQuery?: string): boolean {
    return useMediaQuery(customMediaQuery || "only screen and (max-device-width: 640px)")
}